import React, { useState } from "react";
import { Box, Container, Text, VStack } from "@chakra-ui/react";
import NavBar from "../../../Components/Navbar/NavBar";
import Sales from "./SalesPB";
import Reports from "./ReportsPB";
import About from "./AboutPB";
import pb_logo from "../../../Assets/pb_logo.png";
import axios from "axios";

function PB() {
  const [selectedOption, setSelectedOption] = useState("Sales");
  
  const handleTabClick = async (tab) => {
    setSelectedOption(tab);
    const resJWTTableau = await axios.get(
      `${process.env.REACT_APP_BACKEND_API_URL}/generatejwt`,
      { withCredentials: true }
    );
    localStorage.setItem("tableauToken", resJWTTableau.data);
  };

  const renderContent = () => {
    switch (selectedOption) {
      case "Sales":
        return <Sales content="Sales PB" color="blue" />;
      case "Reports":
        return <Reports content="Reports PB" />;
      case "About":
        return <About content="About PB" />;
      default:
        return <Sales content="Sales PB" color="blue" />;
    }
  };

  return (
    <Box h="100vh" bg="gray.50" overflow="hidden">
      <NavBar 
        tabIndicatorColor="blue.500" 
        logo={pb_logo} 
        onTabClick={handleTabClick} 
      />
      
      <Box bg="white" w="100%" h="calc(100vh - 60px)" overflow="hidden">
        {renderContent()}
      </Box>
    </Box>
  );
}

export default PB;
